<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';

const props = defineProps({
  screenId: {
    type: String,
    required: true
  },
  returnSearchPageUrl: {
    type: String,
    default: url.page.returnSearch
  },
  returnBoxPageUrl: {
    type: String,
    default: url.page.returnBox
  }
});

const goToReturnSearch = () => {
  router.push(props.returnSearchPageUrl);
}

const goToReturnBox = () => {
  const modal = document.getElementById('addToReturnBoxCompleteModal');
  const bsModal = bootstrap.Modal.getInstance(modal);
  bsModal?.hide();

  router.push(props.returnBoxPageUrl);
}

</script>

<template>
  <div class="modal com_modal2 fade" id="addToReturnBoxCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1">商品を返品ボックスに追加しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" v-if="props.screenId === 'ReturnSearch'" data-bs-dismiss="modal">商品選択を続ける</button>
          <button type="button" class="btn com_btn1 wd1" v-else-if="props.screenId === 'ReturnHistory'" data-bs-dismiss="modal">返品履歴に戻る</button>
          <button type="button" class="btn com_btn1 wd1" v-else @click="goToReturnSearch">返品依頼TOPに戻る</button>
          <button type="button" class="btn com_btn1 wd1" @click="goToReturnBox">返品ボックスへ移動</button>
        </div>
      </div>
    </div>
  </div>
</template>